import { createSelector } from '@ngrx/store';

import * as fromResearchers from './um-researcher.reducer';
import { selectDashboardState } from '../dashboard.selectors';

export const umResearchersFeatureKey = 'umResearchers';

export const selectUmResearchersState = createSelector(selectDashboardState, (dashboard) => dashboard?.umResearcher);

export const selectUmResearchers = createSelector(selectUmResearchersState, fromResearchers.selectAll);

export const selectIsUmResearchersLoading = createSelector(
  selectUmResearchersState,
  (umResearchersState) => umResearchersState?.loadingUmResearchers
);

export const selectIsUmResearchersLoaded = createSelector(
  selectUmResearchersState,
  (umResearchersState) => umResearchersState?.umResearchersLoaded
);

export const selectSelectedUmResearcher = createSelector(
  selectUmResearchersState,
  (umResearchersState) => umResearchersState?.selectedUmResearcher
);

export const selectUmResearcherById = createSelector(selectUmResearchers, (umResearchers, props) =>
  umResearchers.find((umResearcher) => {
    return umResearcher?.id === +props?.researcherId;
  })
);
